import * as React from 'react';

import classNames from 'classnames';

import styles from './add-button-row.module.css';

type Props = {
    width?: number;
    buttonText: string;
    onClick: () => void;
    getRef?: (ref?: HTMLDivElement | null | undefined) => void;
    isDisabled?: boolean;
};

export const AddButtonRow = (props: Props) => {
    const {width, onClick, buttonText, isDisabled} = props;

    const handleClick = () => {
        if (isDisabled) {
            return;
        }

        onClick();
    };

    const containerClassName = classNames(styles['add-button-container'], {
        [styles['add-button-container--disabled']]: isDisabled,
    });

    return (
        <div
            style={{width: width}}
            onClick={handleClick}
            ref={props.getRef}
            className={containerClassName}
        >
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    handleClick();
                }}
                className={styles['add-button']}
            >
                {buttonText}
            </button>
        </div>
    );
};
